import { Grid, createTheme, ThemeProvider, CssBaseline } from "@mui/material";
import * as React from "react";
import LoginPanel from "components/mnl/auth/loginPanel";
import ResetPasswordForm from "components/mnl/auth/resetPasswordForm";
const theme = createTheme();
const ResetPasswordPage = () => {
  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ height: "100vh" }}>
        <CssBaseline />
        <LoginPanel />
        <ResetPasswordForm />
      </Grid>
    </ThemeProvider>
  );
};
export default ResetPasswordPage;
